import React, { useState, useRef, useEffect } from "react";
import "../styles/KpiSettingsModal.css";

// Shared rich chart-type picker (icon + label, grouped, searchable-by-eye)
// used both by the Global/Tab/KPI Settings modal and by the per-KPI "Chart:"
// control in TabContent, so every chart-type dropdown in the dashboard
// builder looks and behaves the same way.
//
// `groups`: [{ group?: string, charts: [{ value, label, Icon }] }]
export default function ChartTypeDropdown({ value, groups, onChange, placeholder = "Select chart type" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const allCharts = groups.flatMap((g) => g.charts);
  // Case-insensitive: some KPIs were saved with a capitalized default (e.g.
  // "Bar") before that was fixed, and ChartRenderer itself lowercases the
  // type before matching — match the same way here so the trigger doesn't
  // show a blank placeholder for that older data.
  const selected = allCharts.find((c) => c.value === value?.toLowerCase?.());
  const SelectedIcon = selected?.Icon;

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="ksm-chart-dropdown">
      <button type="button" className="ksm-chart-trigger" onClick={() => setOpen((o) => !o)}>
        {SelectedIcon && (
          <span className="ksm-chart-trigger-icon"><SelectedIcon size={14} /></span>
        )}
        <span className="ksm-chart-trigger-label">{selected?.label || placeholder}</span>
        <span className="ksm-chart-trigger-arrow">▾</span>
      </button>

      {open && (
        <div className="ksm-chart-menu">
          {groups.map((group, gi) => (
            <div key={group.group || gi}>
              {gi > 0 && <div className="ksm-chart-divider" />}
              {group.group && <div className="ksm-chart-group-label">{group.group}</div>}
              {group.charts.map(({ value: cv, label, Icon }) => (
                <button
                  type="button"
                  key={cv}
                  className={`ksm-chart-option${value?.toLowerCase?.() === cv ? " ksm-chart-option--active" : ""}`}
                  onClick={() => { onChange(cv); setOpen(false); }}
                >
                  {Icon && <Icon size={14} />}
                  {label}
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
